import { useState } from 'react';
import { Button, Paper, Typography, Grid } from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import EnvironmentBadge from '../../common/EnvironmentBadge';
import StatusBadge from '../../common/StatusBadge';
import { useStyles } from '../../../../styles';
import './styles/projectContextHeader.css';

interface ProjectContextHeaderProps {
  projectName: string;
  appUrl: string;
  environment: string;
  testPlanName: string;
  testSuiteName: string;
  lastRunDate: Date | null;
  testPlanVersion: string | null;
  testPlanUrl?: string;
  projectStatus?: string;
  frontendRepositoryName: string | null;
  frontendRepositoryUrl: string | null;
  frontendRepositoryBranch: string | null;
  // playwrightRepositoryUrl: string | null;
  hasPreviousRuns?: boolean;
}

export default function ProjectContextHeader({
  projectName,
  environment,
  appUrl,
  testPlanName,
  testSuiteName,
  lastRunDate,
  testPlanUrl,
  projectStatus,
  frontendRepositoryName,
  frontendRepositoryUrl,
  frontendRepositoryBranch,
  // playwrightRepositoryUrl,
  hasPreviousRuns = false,
}: ProjectContextHeaderProps) {
  const classes = useStyles();
  const [showMore, setShowMore] = useState(false);

  return (
    <Paper className={classes.overwiewCards}>
      <Grid container spacing={2} className={classes.toolGrid}>
        <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
          <Typography className={classes.apmLabel}>Project</Typography>
          <Typography
            variant="body2"
            className={`${classes.apmValue} ec-context-value`}
          >
            <span>{projectName}</span>
          </Typography>
        </Grid>
        <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
          <Typography className={classes.apmLabel}>Environment</Typography>
          <EnvironmentBadge environment={environment} />
        </Grid>
        <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
          <Typography className={classes.apmLabel}>Status</Typography>
          {projectStatus && (
            <StatusBadge
              status={projectStatus}
              hasPreviousRuns={hasPreviousRuns}
            />
          )}
        </Grid>
        <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
          <Typography className={classes.apmLabel}>App Url</Typography>
          <Typography
            variant="body2"
            className={`${classes.apmValue} ec-context-value`}
          >
            {appUrl ? (
              <a
                href={appUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="ec-context-link"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                {appUrl}
              </a>
            ) : (
              <Typography variant="body2" className={classes.apmValue}>
                <span>—</span>
              </Typography>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} className="ec-context-toggle">
          <Button
            variant="text"
            color="primary"
            className="ec-context-toggle-button"
            onClick={() => setShowMore(current => !current)}
            endIcon={showMore ? <ExpandLess /> : <ExpandMore />}
          >
            {showMore ? 'Show less' : 'Show more'}
          </Button>
        </Grid>
        {showMore && (
          <>
            <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
              <Typography className={classes.apmLabel}>
                Last Run date
              </Typography>
              <Typography
                variant="body2"
                className={`${classes.apmValue} ec-context-value`}
              >
                <span>{lastRunDate?.toLocaleDateString() || '—'}</span>
              </Typography>
            </Grid>
            <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
              <Typography className={classes.apmLabel}>Test Plan</Typography>
              <Typography
                variant="body2"
                className={`${classes.apmValue} ec-context-value`}
              >
                <span>{testPlanName}</span>
              </Typography>
            </Grid>
            <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
              <Typography className={classes.apmLabel}>Test Suite</Typography>
              <Typography variant="body2" className={classes.apmValue}>
                <span>{testSuiteName}</span>
              </Typography>
            </Grid>

            <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
              <Typography className={classes.apmLabel}>
                Test Plan URL
              </Typography>
              {testPlanUrl ? (
                <a
                  href={testPlanUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ec-context-link ec-context-test-plan-link"
                  style={{ color: 'inherit', textDecoration: 'underline' }}
                >
                  {testPlanUrl}
                </a>
              ) : (
                <Typography variant="body2" className={classes.apmValue}>
                  <span>—</span>
                </Typography>
              )}
            </Grid>
            <Grid item md={3} sm={4} xs={6}>
              <Typography className={classes.apmLabel}>
                Frontend Repository Name
              </Typography>
              <Typography variant="body2" className={classes.apmValue}>
                <span>{frontendRepositoryName || '—'}</span>
              </Typography>
            </Grid>
            <Grid item md={3} sm={4} xs={6} className="ec-context-grid-item">
              <Typography className={classes.apmLabel}>
                Frontend Repository URL
              </Typography>
              {frontendRepositoryUrl ? (
                <a
                  href={frontendRepositoryUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ec-context-link ec-context-test-plan-link"
                  style={{ color: 'inherit', textDecoration: 'underline' }}
                >
                  {frontendRepositoryUrl}
                </a>
              ) : (
                <Typography variant="body2" className={classes.apmValue}>
                  <span>—</span>
                </Typography>
              )}
            </Grid>
            <Grid item md={3} sm={4} xs={6}>
              <Typography className={classes.apmLabel}>
                Frontend Repository Branch
              </Typography>
              <Typography variant="body2" className={classes.apmValue}>
                <span>{frontendRepositoryBranch || '—'}</span>
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  );
}
